module.exports = __webpack_public_path__ + "img/ml.90ca9750.svg";